@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1>{{ pageTitle }}</h1>

@if (!isLoading) {
  <mat-card class="results-card">
    @if (hasAnyResults()) {
      <div class="results-content">
        <div class="result-columns">
          <div class="result-column w-50">
            <app-simulation-overview
              [simulationResponse]="simulationResponse"
              [directions]="['x', 'y', 'z']"
            ></app-simulation-overview>
            <mat-expansion-panel [expanded]="false" style="margin-top: 10px;">
              <mat-expansion-panel-header>
                <mat-panel-title>Simulation Processing Times</mat-panel-title>
              </mat-expansion-panel-header>
              <app-simulation-directions-table
                [simulationResponse]="simulationResponse"
                [directions]="['x', 'y', 'z']"
              ></app-simulation-directions-table>
            </mat-expansion-panel>
          </div>
          <div class="result-column w-50">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>Simulation Parameters</mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <form [formGroup]="directionsForm">
                  <div class="input-row">
                    <span>Directions</span>
                    <div class="direction-options">
                      <mat-checkbox formControlName="x">X</mat-checkbox>
                      <mat-checkbox formControlName="y">Y</mat-checkbox>
                      <mat-checkbox formControlName="z">Z</mat-checkbox>
                    </div>
                  </div>
                </form>
              </div>
            </mat-expansion-panel>
          </div>
        </div>
        @if (!allResultsInvalid) {
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Results</mat-panel-title>
              <button
                mat-raised-button
                color="primary"
                type="button"
                [disabled]="!checkIfAtLeastOneDirectionSelected()"
                (click)="downloadResults(); $event.stopPropagation()"
                class="header-button"
                >
                <mat-icon>download</mat-icon>
                Download
              </button>
            </mat-expansion-panel-header>
            @if (tableData.length) {
              <table class="results-table">
                <thead>
                  <tr>
                    <th>Direction</th>
                    <th>Total porosity (%)</th>
                    <th>Connected porosity (%)</th>
                    <th>Formation factor</th>
                  </tr>
                </thead>
                <tbody>
                  @for (data of tableData; track data) {
                    <tr>
                      <td class="direction-cell">{{ data.direction }}</td>
                      <td class="data-cell">{{ data.totalPorosity }}</td>
                      <td class="data-cell">{{ data.connectedPorosity }}</td>
                      <td class="data-cell">{{ data.formationFactor }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div class="no-table-data">
                <p>No data. Please select the direction to display simulation results.</p>
              </div>
            }
          </mat-expansion-panel>
        } @else {
          <div class="no-results">
            <mat-icon class="no-results-icon">info</mat-icon>
            <p>No result available.</p>
          </div>
        }
      </div>
    } @else {
      <div class="no-results padding">
        <mat-icon class="no-results-icon">info</mat-icon>
        <p>No result available for this simulation yet.</p>
      </div>
    }
  </mat-card>
}



